import React from "react";
import TicketItem from "./TicketItem/TicketItem";
import { ChantInput } from "../../../../../CommonComponents";
import ChantSelect from "../../../../../CommonComponents/ChantSelect/ChantSelect";
import { Tooltip } from "antd";

const TicketItemsSection = ({
  type,
  ticketsToRender,
  tickets,
  soldTickets,
  ticketTypes,
  ticketLimit,
  quantity,
  price,
  limit,
  passLimit,
  handleInputChange,
  handleOptionChange,
  handleTicketDetailInputChange,
  handleTicketDetailOptionChange,
  handleTicketDetailDelete,
  addTicket,
}) => {
  const limitOptions = (ticketLimit || []).map((lim) => ({
    value: lim,
    label: lim === 0 ? "NA" : String(lim),
  }));

  const passLimitOptions = Array.from({ length: 10 }, (_, i) => ({
    value: i + 1,
    label: String(i + 1),
  }));

  return (
    <div className="ct-section">
      <h3 className="ct-section-title">Ticket Items</h3>

      {type !== "Tailgate Season Pass" ? (
        <>
          {ticketsToRender.map((ticketDetail, index) => (
            <TicketItem
              key={index}
              index={index}
              ticketDetail={ticketDetail}
              handleTicketDetailInputChange={handleTicketDetailInputChange}
              handleTicketDetailOptionChange={handleTicketDetailOptionChange}
              ticketType={type}
              soldTickets={soldTickets}
              ticketTypes={ticketTypes}
              handleTicketDetailDelete={handleTicketDetailDelete}
            />
          ))}
          <button
            type="button"
            className="ct-add-ticket-btn"
            onClick={addTicket}
          >
            <i className="fa fa-plus"></i>
            <span>Add Ticket</span>
          </button>
        </>
      ) : (
        <>
          <div className="ct-season-pass-grid">
            <div className="ct-field">
              <ChantInput
                label={
                  type !== "Tailgate Season Pass"
                    ? "Total Ticket Quantity"
                    : "Total Number of Season Passes"
                }
                value={quantity}
                type="number"
                onChange={handleInputChange}
                name="quantity"
                placeholder="0"
                required
                min={soldTickets !== 0 ? soldTickets : 1}
                helpText="Set number of available tickets for sale."
              />
            </div>

            <div className="ct-field">
              <ChantInput
                label={
                  type !== "Tailgate Season Pass"
                    ? "Price per Ticket"
                    : "Price per Season Pass"
                }
                value={price}
                type="number"
                step="0.01"
                onChange={handleInputChange}
                name="price"
                placeholder="0"
                min={0}
                required
                helpText="If free, enter '0' and member can 'Reserve' tickets."
              />
            </div>

            <div className="ct-field">
              <ChantSelect
                label={
                  type !== "Tailgate Season Pass"
                    ? "Ticket Limit Per Member"
                    : "Number of Tickets in Season Pass"
                }
                required
                value={limit ?? undefined}
                onChange={(value) =>
                  handleOptionChange({
                    target: { name: "limit", value: value === 0 ? "NA" : value },
                  })
                }
                options={limitOptions}
                placeholder="--Select Ticket Limit--"
                helpTooltip={
                  <Tooltip
                    title={
                      type !== "Tailgate Season Pass"
                        ? "If no ticket limit, select N/A"
                        : "Set number of tickets in pass. This value will not be editable for member."
                    }
                  >
                    <i className="fa fa-question-circle-o" />
                  </Tooltip>
                }
              />
            </div>
          </div>

          {type === "Tailgate Season Pass" && (
            <div style={{ maxWidth: 320, marginTop: 20 }}>
              <ChantSelect
                label="Passes Limit Per Member"
                required
                value={passLimit ?? undefined}
                onChange={(value) =>
                  handleOptionChange({
                    target: { name: "passLimit", value },
                  })
                }
                options={passLimitOptions}
                placeholder="--Select Passes Limit--"
                helpTooltip={
                  <Tooltip title="Set number of passes limit per person.">
                    <i className="fa fa-question-circle-o" />
                  </Tooltip>
                }
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TicketItemsSection;
